import React from 'react';
import classNames from 'classnames';
import { activity } from 'dooh-utils';

export class Tap extends React.Component {
  static defaultProps = {
    preventDoubleTap: true,
  };

  constructor(props) {
    super(props);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.state = {
      tapped: false,
    };
  }

  componentDidMount() {
    this.refs.wrapper.addEventListener('touchstart', this.handleTouchStart);
    this.refs.wrapper.addEventListener('mousedown', this.handleTouchStart);
  }

  componentWillUnmount() {
    this.refs.wrapper.removeEventListener('touchstart', this.handleTouchStart);
    this.refs.wrapper.removeEventListener('mousedown', this.handleTouchStart);
  }

  render() {
    return (
      <div
        ref="wrapper"
        className={classNames('Tap', this.props.className)}
        style={this.props.style}
      >
        {this.props.children}
      </div>
    );
  }

  handleTouchStart(e) {
    e.preventDefault();
    if (this.state.tapped && this.props.preventDoubleTap) return;
    this.setState({ tapped: true });
    activity();
    this.props.onTap(e);
  }
}
